<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0 font-small-4">
    Copyright &copy; {{currentDate | date: 'yyyy'}} Mediget
    <span class="version"> v{{ version }} </span>
    <span class="d-none d-sm-inline-block">, All rights reserved.</span>
  </p>
</footer>
<!--Footer Ends-->
